import { batch } from 'react-redux'
import { customizeError, formatDNI } from '@chilecompra/react-kit'

import {
  REACT_APP_API_PRINCIPAL_URL,
  REACT_APP_LOGOUT_UNIQUE_PASS,
  REACT_APP_PROVIDERS_BASE_URL,
  REACT_APP_UNIQUE_PASS_ORIGIN
} from '../../configs/settings/environment'
import { makeActionCreator } from '../../configs/store/utils'
import { getUniquePassToken, getUniquePassUserInfo, logoutUniquePass } from '../../services/auth'

export const CLEAN_PUBLIC_USER = 'CLEAN_PUBLIC_USER'
export const onCleanPublicUser = makeActionCreator(CLEAN_PUBLIC_USER)

export const GET_UNIQUE_KEY_TOKEN = 'GET_UNIQUE_KEY_TOKEN'
export const GET_UNIQUE_KEY_TOKEN_ERROR = 'GET_UNIQUE_KEY_TOKEN_ERROR'
export const GET_UNIQUE_KEY_TOKEN_SUCCESS = 'GET_UNIQUE_KEY_TOKEN_SUCCESS'
export const onGetUniqueKeyToken = makeActionCreator(GET_UNIQUE_KEY_TOKEN)
export const onGetUniqueKeyTokenError = makeActionCreator(GET_UNIQUE_KEY_TOKEN_ERROR, 'payload')
export const onGetUniqueKeyTokenSuccess = makeActionCreator(GET_UNIQUE_KEY_TOKEN_SUCCESS, 'payload')
export const onGetUniqueKeyTokenThunk = payload => async dispatch => {
  const { code, state } = payload || {}

  dispatch(onGetUniqueKeyToken())

  try {
    const { data: uniquePassData } =
      code && state
        ? await getUniquePassToken({
            code,
            state
          })
        : {}

    return dispatch(
      onGetUniqueKeyUserThunk({
        uniquePassData
      })
    )
  } catch (error) {
    return dispatch(
      onGetUniqueKeyTokenError({
        error: customizeError({
          code: error.code,
          originalError: error,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const GET_UNIQUE_KEY_USER = 'GET_UNIQUE_KEY_USER'
export const GET_UNIQUE_KEY_USER_ERROR = 'GET_UNIQUE_KEY_USER_ERROR'
export const GET_UNIQUE_KEY_USER_SUCCESS = 'GET_UNIQUE_KEY_USER_SUCCESS'
export const onGetUniqueKeyUser = makeActionCreator(GET_UNIQUE_KEY_USER)
export const onGetUniqueKeyUserError = makeActionCreator(GET_UNIQUE_KEY_USER_ERROR, 'payload')
export const onGetUniqueKeyUserSuccess = makeActionCreator(GET_UNIQUE_KEY_USER_SUCCESS, 'payload')
export const onGetUniqueKeyUserThunk = payload => async dispatch => {
  const { uniquePassData } = payload || {}

  dispatch(onGetUniqueKeyUser())

  try {
    const { data: uniquePassInfoData } = uniquePassData
      ? await getUniquePassUserInfo({
          token: uniquePassData?.payload?.access_token
        }).catch(error => {
          dispatch(
            onLogoutUniquePassThunk({
              refreshToken: uniquePassData?.payload?.refresh_token
            })
          )

          throw customizeError({
            code: 400,
            originalError: error,
            reason: 'SOMETHING_WENT_WRONG_ERROR'
          })
        })
      : {}

    const {
      preferred_username: number,
      digito_verificador: digit,
      apellidoMaterno: lastName,
      apellidoPaterno: firstName,
      nombres: names
    } = uniquePassInfoData?.payload || {}

    const uniqueKeyDNI = number && digit ? formatDNI(`${number}${digit}`) : ''
    const fullName = `${names} ${firstName} ${lastName}`.trim()

    return batch(() => {
      dispatch(
        onGetUniqueKeyUserSuccess({
          publicUserDni: uniqueKeyDNI,
          publicUserName: fullName
        })
      )
      dispatch(
        onLogoutUniquePassThunk({
          refreshToken: uniquePassData?.payload?.refresh_token
        })
      )
    })
  } catch (error) {
    return dispatch(
      onGetUniqueKeyUserError({
        error
      })
    )
  }
}

export const LOGOUT_UNIQUE_PASS = 'LOGOUT_UNIQUE_PASS'
export const LOGOUT_UNIQUE_PASS_ERROR = 'LOGOUT_UNIQUE_PASS_ERROR'
export const LOGOUT_UNIQUE_PASS_SUCCESS = 'LOGOUT_UNIQUE_PASS_SUCCESS'
export const onLogoutUniquePass = makeActionCreator(LOGOUT_UNIQUE_PASS)
export const onLogoutUniquePassError = makeActionCreator(LOGOUT_UNIQUE_PASS_ERROR, 'payload')
export const onLogoutUniquePassSuccess = makeActionCreator(LOGOUT_UNIQUE_PASS_SUCCESS, 'payload')
export const onLogoutUniquePassThunk = payload => async dispatch => {
  const { refreshToken } = payload || {}

  dispatch(onLogoutUniquePass())

  try {
    await logoutUniquePass({
      refreshToken
    })

    const uniqueKeyLogoutUrl = `${REACT_APP_LOGOUT_UNIQUE_PASS}?redirect=${REACT_APP_PROVIDERS_BASE_URL}/auth/clave-unica/logout`

    window.open(uniqueKeyLogoutUrl, '_blank')

    return dispatch(onLogoutUniquePassSuccess())
  } catch (error) {
    return dispatch(
      onLogoutUniquePassError({
        error
      })
    )
  }
}

export const onSignInUniqueKeyThunk = payload => dispatch => {
  const { csrfToken } = payload || {}

  const uniqueKeyURL = `${REACT_APP_API_PRINCIPAL_URL}/v1/registro-civil/clave-unica/sso/authorize?csrf=${csrfToken}&aplicativo=${REACT_APP_UNIQUE_PASS_ORIGIN}`

  window.open(uniqueKeyURL, '_blank')

  const handleStorage = event => {
    if (event.key === 'auth_callback_data') {
      try {
        const data = JSON.parse(event.newValue)

        if (data?.type === 'AUTH_CALLBACK') {
          const { hashCode, hashState } = data.data

          dispatch(
            onGetUniqueKeyTokenThunk({
              code: hashCode,
              state: hashState
            })
          )
          window.removeEventListener('storage', handleStorage)
          localStorage.removeItem('auth_callback_data')
        }
      } catch (error) {
        console.error('Error processing storage data:', error)
      }
    }
  }

  window.addEventListener('storage', handleStorage)
}
